import React from "react";
import ComponentHeader from "../CommonComponents/componentHeader";
import PayoutsTableSection from "./payoutsTableSection";
import BankDepositSection from "./bankDepositSection";
import PaypalIdentitySection from "./paypalIdentiySection";

const PAYOUTS_COMPONENT = "PAYOUTS_COMPONENT";
const PayoutsWrapper = () => {
    return (
        <>
            <ComponentHeader title="Payouts"/>
            <div className="mt-0 payouts-page-body">
                <BankDepositSection/>
                <PaypalIdentitySection/>
                <PayoutsTableSection/>
            </div>
        </>
    )
}

export default PayoutsWrapper;
export {PAYOUTS_COMPONENT};
